import * as React from 'react';
import clsx from 'clsx';
import { useControllable } from '../../../hooks/useControllable';
import { Base } from '../../Base';
import { SrOnly } from '../../Helper/SrOnly';
import { ChoiceGroupContext } from './ChoiceGroupContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "ChoiceGroup-root_20LDI",
  "column": "ChoiceGroup-column_N3oU-",
  "row": "ChoiceGroup-row_19Ruq"
};
export function ChoiceGroup({
  name,
  defaultValue,
  value: valueProp,
  legend,
  layout,
  minWidth,
  className,
  children,
  onChange,
  onValueChange,
  ...extraProps
}) {
  const style = React.useMemo(() => minWidth ? {
    '--min-width': typeof minWidth === 'number' ? `${minWidth}px` : minWidth
  } : {}, [minWidth]);
  const [value, setValue] = useControllable({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  const context = React.useMemo(() => ({
    name,
    value,
    onValueChange: setValue
  }), [name, value, setValue]);
  return /*#__PURE__*/_jsxs(Base, {
    tagName: "fieldset",
    onChange: onChange,
    style: style,
    className: clsx(styles.root, {
      [styles.column]: layout === 'column',
      [styles.row]: layout === 'row'
    }, className),
    ...extraProps,
    children: [legend ? /*#__PURE__*/_jsx(SrOnly, {
      children: /*#__PURE__*/_jsx(Base, {
        tagName: "legend",
        children: legend
      })
    }) : null, /*#__PURE__*/_jsx(ChoiceGroupContext.Provider, {
      value: context,
      children: children
    })]
  });
}